<template>
  <div>
    <p>
      🤩 מעוניינים להגיש מועמדות? 🤩
      <br>
      להגשת מועמדות >> {{position_link}}
      <br>
      <br>
      💚רוצים להצטרף ולראות משרות חמות בעולם הבניין? 💚
      <br>
      הרשמו עוד היום לאפליקציית Rebase (חינם) וצפו בעשרות משרות מותאמות לכם! ⚡
      <br>
      😎ניתן גם במסלול דיסקרטי 😎
      <br>
      אפליקציית Rebase ליצירה של פרופיל מקצועי (ללא עלות) 📱 ⬅️ https://web.rebase.co.il
      <br>
      לצפייה במשרות שלנו בענף הבנייה והנדל"ן 🏗️ ⬅️ https://rebase.co.il/positions
      <br>
      מומלץ לעקוב אחרינו גם בפייסבוק 🔥 :
      <br>
      https://www.facebook.com/rebase.co.il/
      <br>
      ⭐ לטלגרם שלנו: https://t.me/+3eUQ4QFAWCU0MWY0
      <br>
    </p>
  </div>
</template>
<script>
export default {
  name: 'rebase-footer',
  props: ['position', 'position_link']
}
</script>
